import type { ItemImage } from '@sbt-web/network/types';
import { getOrCreatePulse } from '@/tools/tracking/utils';
import classnames from 'classnames';
import { useEffect, type FC, type JSX } from 'react';

import ownClasses from './index.module.scss';

const thumbnailClickTracking = {
  type: 'Click',
  object: {
    type: 'UIElement',
    '@id': 'sdrn:subito:ad_detail:gallery:element:thumbnail',
    name: 'Desktop Gallery Thumbnail',
    elementType: 'Figure',
  },
  page: {
    pageType: 'ad_detail',
    '@id': 'sdrn:subito:page:ad_detail',
    '@type': 'Page',
  },
};

const trackThumbnailClick = () => {
  getOrCreatePulse()?.queueEvent(thumbnailClickTracking);
};

interface Props {
  images: ItemImage[];
  onClick: (index: number) => void;
  reduceDataUse?: boolean;
  currentIndex: number;
  advThumbnail?: JSX.Element;
  advLoaded?: boolean;
  goToAdv?: boolean;
}

const ruleQuery = '?rule=gallery-thumbnail-desktop';

const Thumbnails: FC<Props> = (props) => {
  useEffect(() => {
    // requestIdleCallback is necessary to fix an incorrect positioning of the scroll in chrome
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(() => {
        const img = document.getElementById(
          `ad-gallery-thumbnail-${props.currentIndex}`
        );
        img?.scrollIntoView?.({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest',
        });
      });
    }
  }, [props.currentIndex]);

  if (props.images.length === 0) {
    return null;
  }

  const thumbnails = props.images.map((img, index) => {
    return (
      <button
        key={img.cdnBaseUrl}
        className={classnames(ownClasses['thumbnail-cell'], {
          [ownClasses['thumbnail-cell--selected']]:
            index === props.currentIndex && !props.goToAdv,
        })}
        onClick={() => {
          trackThumbnailClick();
          props.onClick(index);
        }}
        aria-labelledby={`ad-gallery-thumbnail-${index}`}
      >
        <img
          src={`${img.cdnBaseUrl}${ruleQuery}-1x-auto`}
          srcSet={
            props.reduceDataUse
              ? undefined
              : `${img.cdnBaseUrl}${ruleQuery}-1x-auto 1x, ${img.cdnBaseUrl}${ruleQuery}-2x-auto 2x, ${img.cdnBaseUrl}${ruleQuery}-3x-auto 3x`
          }
          id={`ad-gallery-thumbnail-${index}`}
          className={ownClasses.thumbnail}
          alt={`Immagine ${index + 1}`}
          width="64"
          height="48"
          decoding="async"
          loading={index >= 15 ? 'lazy' : undefined}
          // @ts-expect-error This is a new attribute.
          // eslint-disable-next-line react/no-unknown-property
          fetchpriority="low"
        />
      </button>
    );
  });

  return (
    <nav className={ownClasses['thumbnail-wrapper']}>
      {thumbnails}
      {props.advLoaded ? props.advThumbnail : null}
    </nav>
  );
};

export default Thumbnails;
